import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsfigure',
	templateUrl:'./BSFigurePluginCompPage.html',
	styles: [],
	styleUrls:['./BSFigurePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSFigurePluginCompPage
{
	mdContent_815 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.figures.BSFigure;
\`\`\``;
	mdContent_816 = `\`\`\`java
BSFigure()
\`\`\``;
	mdContent_817 = `\`\`\`java
BSFigure&lt;?&gt; fig = new BSFigure&lt;&gt;();
fig.setImageUrl("/img/photo.jpg");
fig.setCaption("A beautiful sunset");
\`\`\``;
}
